
export class TestServiceMethodsData {
    public resultOfPriorCalls = {};
    public priorMethodName: string = null;
}

export interface ICallServiceMethod {
    methodName: string;
    repeatMethodNumTimes: number;
    //callExpr: (service: FolderPermissionService, testServiceMethodsData: TestServiceMethodsData) => Promise<object>;
    callExpr: (service: object, testServiceMethodsData: TestServiceMethodsData) => Promise<object>;
}
export class CallServiceMethod {
    public methodName: string;
    public repeatMethodNumTimes: number = 0;
    //public callExpr: (service: FolderPermissionService, testServiceMethodsData: TestServiceMethodsData) => Promise<object>;
    public callExpr: (service: object, testServiceMethodsData: TestServiceMethodsData) => Promise<object>;

    public constructor(data: ICallServiceMethod) {
        this.methodName = data.methodName;
        this.repeatMethodNumTimes = data.repeatMethodNumTimes;
        this.callExpr = data.callExpr;
    }

    // Method to test a service.
    public static testServiceMethods(serviceName: string, service: object, callServiceMethods: CallServiceMethod[], testServiceMethodsData: TestServiceMethodsData, methodIndex: number = 0, methodIterationIndex: number = 0): void {
        // Define the logic to call service methods in succession.
        //
        // Call service methods in succession until all have been called or an error occurs.

        let nextMethodInfo: CallServiceMethod = callServiceMethods[methodIndex];
        console.log(`${serviceName}.testServiceMethods():  calling service method ${nextMethodInfo.methodName} ...`);

        let promise: Promise<object> = nextMethodInfo.callExpr(service, testServiceMethodsData);
        promise.then(response => {
            testServiceMethodsData.resultOfPriorCalls[nextMethodInfo.methodName] = response;
            if ((methodIterationIndex < nextMethodInfo.repeatMethodNumTimes) || (methodIndex < callServiceMethods.length - 1)) {
                let nextMethodName: string = methodIterationIndex < nextMethodInfo.repeatMethodNumTimes ?
                    callServiceMethods[methodIndex].methodName :
                    callServiceMethods[methodIndex + 1].methodName;
                if (methodIterationIndex < nextMethodInfo.repeatMethodNumTimes)
                    CallServiceMethod.testServiceMethods(serviceName, service, callServiceMethods, testServiceMethodsData, methodIndex, methodIterationIndex + 1);
                else if (methodIndex < callServiceMethods.length - 1)
                    CallServiceMethod.testServiceMethods(serviceName, service, callServiceMethods, testServiceMethodsData, methodIndex + 1);
                else
                    throw `${serviceName}.testserviceMethods():  could not find next method '${nextMethodName}'.`;
            } else {
                console.log(`${serviceName}.testserviceMethods():  completed testing without error!`);
            }
        });
    }

}
